// Fachada do domínio Activity — métodos das instâncias (ver core.ts).
// Consumidores importam o comportamento daqui, com os MESMOS nomes dos
// services antigos.
import { activitiesService, flowConfigService, cadenceService } from './core';

// ── Funções puras + tipos (re-export direto do módulo) ──────────
export {
  cardOwnerForActivity,
  ACTIVITY_TYPES,
  getTypeMeta,
  classifyByUrgency,
} from '@modules/activity';
export type {
  UrgencyBuckets,
  ListPendingActivitiesParams,
  CreateActivityParams,
  StageRoleInfo,
  PipelineFull,
  ActionOnComplete,
  OnCompletePlan,
  ExecuteResult,
  NextStage,
  TriggerStageCadenceParams,
  TeamMemberRow,
} from '@modules/activity';

// ── activitiesService ───────────────────────────────────────────
export const listActivitiesByLead          = activitiesService.listActivitiesByLead;
export const listActivityTeam              = activitiesService.listActivityTeam;
export const listPendingActivities         = activitiesService.listPendingActivities;
export const createActivity                = activitiesService.createActivity;
export const completeActivity              = activitiesService.completeActivity;
export const listPendingActivityIdsForCard = activitiesService.listPendingActivityIdsForCard;
export const cancelActivitiesByIds         = activitiesService.cancelActivitiesByIds;
export const cancelActivity                = activitiesService.cancelActivity;
export const reopenActivity                = activitiesService.reopenActivity;
export const snoozeActivity                = activitiesService.snoozeActivity;

// ── flowConfigService ───────────────────────────────────────────
export const getStageByRole          = flowConfigService.getStageByRole;
export const setStageRole            = flowConfigService.setStageRole;
export const setStageEmpresaGate     = flowConfigService.setStageEmpresaGate;
export const getCloserPipeline       = flowConfigService.getCloserPipeline;
export const setCloserPipeline       = flowConfigService.setCloserPipeline;
export const getActionOnComplete     = flowConfigService.getActionOnComplete;
export const resolveOnCompletePlan   = flowConfigService.resolveOnCompletePlan;
export const executeOnCompleteAction = flowConfigService.executeOnCompleteAction;

// ── cadenceService ──────────────────────────────────────────────
export const triggerStageCadence = cadenceService.triggerStageCadence;
export const getNextStage        = cadenceService.getNextStage;
export const getPipelineCadence  = cadenceService.getPipelineCadence;
export const setPipelineCadence  = cadenceService.setPipelineCadence;
